import React from "react";
import { ThumbnailsPane, ThumbImg } from "@embedpdf/plugin-thumbnail/react";
import type { ThumbMeta } from "@embedpdf/plugin-thumbnail/react";

interface PdfThumbnailsProps {
  documentId: string;
  /** Thumbnail image width in px. */
  width: number;
  /** 1-based current page, used to highlight the active thumbnail. */
  currentPage: number;
  /** Called with a 1-based page number when a thumbnail is clicked. */
  onSelect: (pageNumber: number) => void;
}

/**
 * Default thumbnail sidebar. The underlying `ThumbnailsPane` is a virtualised,
 * self-scrolling container that calls its render-prop once per visible page,
 * handing us a positioned {@link ThumbMeta}.
 */
export function PdfThumbnails({
  documentId,
  width,
  currentPage,
  onSelect,
}: PdfThumbnailsProps) {
  return (
    <div className="pdf-renderer__thumbnails" style={{ width: width + 24 }}>
      <ThumbnailsPane
        documentId={documentId}
        style={{ width: "100%", height: "100%" }}
      >
        {(meta: ThumbMeta) => {
          const isActive = meta.pageIndex + 1 === currentPage;
          return (
            <div
              key={meta.pageIndex}
              className={[
                "pdf-renderer__thumb",
                isActive ? "pdf-renderer__thumb--active" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              style={{
                position: "absolute",
                top: meta.top,
                left: 0,
                width: "100%",
                height: meta.wrapperHeight,
              }}
              onClick={() => onSelect(meta.pageIndex + 1)}
            >
              <ThumbImg
                documentId={documentId}
                meta={meta}
                className="pdf-renderer__thumb-img"
                style={{ width: meta.width, height: meta.height }}
              />
              {meta.labelHeight > 0 && (
                <span
                  className="pdf-renderer__thumb-label"
                  style={{ height: meta.labelHeight }}
                >
                  {meta.pageIndex + 1}
                </span>
              )}
            </div>
          );
        }}
      </ThumbnailsPane>
    </div>
  );
}

export default PdfThumbnails;
